export const getFormContent = () => ({
  jurisdictionSelection: {
    selectCountryTitle: 'forms.select-country-title',
    changeCountryTitle: 'forms.button-add-more-jurisdictions',
    moreJurisdictionsTitle: 'forms.more-jurisdictions-title',
    moreJurisdictionsDescription: 'forms.more-jurisdictions-desc',
    contactDescription: 'forms.not-listed-country-title',
    modalSearchPlaceholder: 'search-country-placeholder',
  },
  contactDetailsTitle: 'forms.your-contact-details-title',
  contactNote: {
    title: 'forms.contact-note-title',
    description: 'forms.contact-note-desc',
    optionalLabel: 'note-optional-label',
    placeholder: 'note-placeholder',
    returningClientButtonText: 'forms.contact-note-returning-client-title',
  },
  addTrademarkButton: 'forms.add-trademark-button',
  addAnotherTrademarkButton: 'forms.add-another-trademark-button',
})
